import { useQuery } from '@tanstack/react-query';
import { Category } from '../types';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export function useListCategories() {
  return useQuery<Category[]>({
    queryKey: ['categories'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/integrations/plaid/categories`);
      return response.json();
    },
  });
} 